let interval = setInterval(function () {
  let apElements = document.querySelector(".avpoptions-container__v2");
  if (apElements) {
    let inputItems = document.querySelectorAll(
      ".ap-options__swatch input.avp-productoptiontextcolor"
    );
    for (let inputItem of inputItems) {
      if (inputItem.checked) {
        inputItem.parentElement.parentElement.parentElement.classList.add(
          "apo-checked"
        );
      } else {
        inputItem.parentElement.parentElement.parentElement.classList.remove(
          "apo-checked"
        );
      }
    }
  }
}, 100);